import {GenWeatherBaseline} from '../../../generated/serverModels/GenWeatherBaseline';

export class WeatherBaseline extends GenWeatherBaseline {
  public weatherEventNames: string;


  constructor(weatherBaseline?: WeatherBaseline | GenWeatherBaseline) {
    super(weatherBaseline);

    if (weatherBaseline) {
      this.weatherEventNames = weatherBaseline.weatherPhenoms.map(phenom => phenom.displayName).join(', ');
    }

  }
}
